module.exports = __webpack_public_path__ + "img/brume_mob.3d775ce.webp";